import WarehousePackagesList from "./PackagesList";

export default function WarehouseShipped() {
  return (
    <WarehousePackagesList
      status="SHIPPED_OUT"
      title="Shipped Out from Warehouse"
      description="Packages already shipped out from this warehouse, awaiting last-mile staging."
    />
  );
}
